export default "__VITE_ASSET__CtXm6PiI__"